module.exports = __webpack_public_path__ + "img/iphone-charging-NETHERLANDS-nl.d88444af.png";